/**
 * Provides a breakdown of modified counts in the asset tags inventory.
 * This is displayed in the admin table footer.
 */
import React from 'react';
import { observer } from 'mobx-react';
import pluralize from '@kentik/ui-shared/util/pluralize';
import { Flex, Icon, Text } from 'core/components';
import AssetTagInventoryCollection from 'app/stores/assetTags/AssetTagInventoryCollection';

interface Props {
  collection: AssetTagInventoryCollection;
}

function EditCounts({ collection }: Props) {
  const { errorCount, addedCount, editedCount, removedCount, unchangedCount } = collection;

  return (
    <Flex gap={1} mr={1}>
      {/* ex: 1 error, 8 added, 5 edited, 2 removed, 3 unchanged */}
      {[
        { label: pluralize('error', errorCount), count: errorCount, icon: 'error', color: 'danger' },
        { label: 'added', count: addedCount, icon: 'add', color: 'success' },
        { label: 'edited', count: editedCount, icon: 'edit', color: 'primary' },
        { label: 'removed', count: removedCount, icon: 'trash', color: 'danger' },
        { label: 'unchanged', count: unchangedCount, icon: 'lock', color: 'muted' }
      ].map(({ label, count, icon, color }) => {
        if (count > 0) {
          return (
            <Text key={label} small>
              <Icon icon={icon} iconSize={14} color={color} mr={1} />
              {count} {label}
            </Text>
          );
        }

        return null;
      })}
    </Flex>
  );
}

export default observer(EditCounts);
